import { Messages } from "primereact/messages";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { getVesselInspectionData } from "../../queries/particularsQueries";
import { useParams } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { AppContext } from "../../App";
import { AppContextType } from "../../types/AppContextType";

export const EarlyReleaseMessage = () => {
    const { user } = useAuthenticator((context) => [context.authStatus, context.user]);
    const { inspectionId } = useParams();
    const earlyReleaseRef: any = useRef(null);
    const { t } = useTranslation("locale");
    const { setEarlyRelease } = React.useContext(
        AppContext
    ) as AppContextType;


    const message = t("report.earlyReleaseMessage");

    const { data, isLoading } = getVesselInspectionData(
        inspectionId ?? "",
        user
    );

    useEffect(() => {

        if (!isLoading) {
            if (earlyReleaseRef.current) {
                earlyReleaseRef.current.clear();
                earlyReleaseRef.current.show({
                    sticky: true,
                    severity: "warn",
                    summary: "",
                    detail: message,
                    closable: true
                });
            }

            if(data?.earlyRelease){
                setEarlyRelease(true);
            }
        }

    }, [isLoading]);


    if (isLoading || !data?.earlyRelease) {
        return <></>;
    }

    return (
        <Messages ref={earlyReleaseRef} />
    );
};